import { Typography } from "@commonlibs";
import { useTranslate } from "ui/locale";
import { CircleCheckIconRoot, SuccessfulRegistrationMessage, SuccessfulRegistrationPageRoot } from "./SuccessfulRegistrationPage.styles";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthRoutes } from "ui/auth/router/AuthRouter.types";

export default function SuccessfulRegistrationPage(): JSX.Element {
    const translate = useTranslate();
    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            navigate(AuthRoutes.LOGIN);
        }, 4000);
    }, []);
    return (
        <SuccessfulRegistrationPageRoot>
            <CircleCheckIconRoot />
            <Typography textAlign="center" variant="h4Strong" color="green.200">
                {translate("registrationFinished")}
            </Typography>
            <SuccessfulRegistrationMessage>
                <Typography variant="h5Regular" color="gray.450">
                    {translate("registrationFinishedMessage1")}
                </Typography>
                <Typography variant="h5Strong" color="primary" style={{ marginLeft: "4px" }}>
                    {translate("registrationFinishedMessage2")}
                </Typography>
            </SuccessfulRegistrationMessage>
        </SuccessfulRegistrationPageRoot>
    );
}
